import * as types from '../types'
// import axios from 'axios'
import router from '../../router'
import MQL from "@/plugins/mql.js";
export const state = {
  token: sessionStorage.getItem('user-token') || '',
  status: '',
  ipDetails: {},
  copyrightInfo: ""
}

export const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getIPDetails: state => state.ipDetails,
  getCopyrightInfo: state => state.copyrightInfo


}

export const mutations = {

  [types.MUTATE_AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },

  [types.MUTATE_AUTH_SUCCESS]: (state, token) => {
    state.status = 'success'
    state.token = token
  },

  [types.MUTATE_AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [types.SET_IP_DETAILS]: (state, payload) => {
    state.ipDetails = payload
  },
  [types.SET_COPYRIGHT_INFO]: (state, payload) => {
    state.copyrightInfo = payload
  },
  [types.MUTATE_CLEAR_STORE]: (state) => {
    state.status = ''
    state.ipDetails = {}
    state.copyrightInfo = ""
  },
}

export const actions = {
  AUTH_REQUEST: ({
    commit
  }, payload) => {
    return new Promise((resolve, reject) => {
      // console.log("HEI")
      commit(types.MUTATE_AUTH_REQUEST, payload)
      new MQL()
        .setActivity("o.[LoginService]")
        .setData(payload)
        .fetch()
        .then(rs => {
          let res = rs.getActivity("LoginService", true)
          if (rs.isValid("LoginService")) {
            commit(types.MUTATE_AUTH_SUCCESS, res)
            // console.log("RES FRM L:", res)
            resolve(res)
          } else {
            commit(types.MUTATE_AUTH_ERROR, res.error)
            sessionStorage.removeItem('user-token')
            rs.showErrorToast("LoginService")
          }
        })
    })
  },
  /* AUTH_REQUEST: ({
    commit
  }, payload) => {
    return new Promise((resolve, reject) => {
      commit(types.MUTATE_AUTH_REQUEST, payload)
      sessionStorage.setItem('user-token', 'token')
      // axios.defaults.headers.common['Authorization'] = 'token'
      axios.post('o/mql/login', payload).then(response => {
          var token = response.headers.authorization
          sessionStorage.setItem('user-token', token)
          // set axios header
          // axios.defaults.headers.common['Authorization'] = token
          commit(types.MUTATE_AUTH_SUCCESS, response)
          resolve(response)
        })
        .catch(err => {
          commit(types.MUTATE_AUTH_ERROR, err)
          sessionStorage.removeItem('user-token')
          reject(err)
        })
    })
  }, */

  AUTH_LOGOUT: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      sessionStorage.removeItem('user-token')
      commit(types.MUTATE_CLEAR_STORE, {})
      // remove the axios default header
      // delete axios.defaults.headers.common['Authorization']
      router.push({
        name: 'login'
      })
      resolve()
    })
  }
}

/* export default {
  state,
  getters,
  mutations,
  actions
} */